import React, { useEffect, useState, useCallback } from 'react';
import { ButtonCreateService } from './components/ButtonCreateService';
import { TableListService } from './components/TableListService';
import { ModalService } from './components/ModalService';
import styles from './ListService.module.scss';
import { useDispatch } from 'react-redux';
import {
  loadListService,
  createService,
  updateService,
} from '../../../../redux/asyncActions/listService';
import { loadOrganizationTypes } from '../../../../redux/asyncActions/dictionaries';

export const ListService = () => {
  const dispatch = useDispatch();

  const [mode, setMode] = useState(null);
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    dispatch(loadListService());
    dispatch(loadOrganizationTypes());
  }, [dispatch]);

  const openCreate = useCallback(() => {
    setCurrent(null);
    setMode('create');
  }, []);

  const openEdit = useCallback((service) => {
    setCurrent(service);
    setMode('edit');
  }, []);

  const close = useCallback(() => setMode(null), []);

  const handleSubmit = useCallback(
    ({ mode, values }) => {
      const action = mode === 'create' ? createService(values) : updateService(values);
      return dispatch(action);
    },
    [dispatch]
  );

  return (
    <div>
      <div className={styles.containerButtonCreateService}>
        <ButtonCreateService openCreate={openCreate} />
      </div>

      <TableListService onEdit={openEdit} />

      {mode && (
        <ModalService
          mode={mode}
          open={!!mode}
          initialValues={current}
          onCancel={close}
          onSubmit={handleSubmit}
        />
      )}
    </div>
  );
};
